import {ValidationType} from './ValidationType'

export const NewsValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  NewsDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  Subject: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: true,
    maxLength: 255,
    maxValue: 0
  },
  Body: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  WebPage: {
    validationType: ValidationType.WebPage,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  SiteID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Pictures: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  UploadPictures: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Attachments: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  UpdatedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  InActive: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  }
};
